import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Clarity from "./sections/Clarity";
import Standard from "./sections/Standard";
import TaxSolutions from "./sections/TaxSolutions";
import Impact from "./sections/Impact";
import Testimonials from "./sections/Testimonials";
import Secure from "./sections/Secure";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Clarity />
      <Standard />
      <TaxSolutions />
      <Impact />
      <Testimonials />
      <Secure />
      <Footer />
    </div>;
}